import httpRequest from "../_Services/httpRequest";

export const getSubscription = async (companyId, subscriptionId) => {
    return await httpRequest.get(`/integrations/stripe/subscriptions/${subscriptionId}`, {
        headers: {'Pai-Company': companyId}}
    )
}

export const createCustomer = async (customerData) => {
    return await httpRequest.post(`/integrations/stripe/customers`, customerData);
}

export const updateCustomer = async (companyId, customerId, params) => {
    return await httpRequest.put(`/integrations/stripe/customers/${customerId}`, params, {
        headers: {'Pai-Company': companyId }
    });
}

export const searchCustomer = async (query) => {
    return await httpRequest.get(`/integrations/stripe/customers/search`, {
        params: {
            query: query
        }
    });
}

export const retrieveInvoice = async (companyId, customerId, invoiceId) => {
    return await httpRequest.get(`/integrations/stripe/invoices/${invoiceId}`, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const getUpcomingInvoice = async (companyId, customerId, subscriptionId) => {
    const params = new URLSearchParams([
        ['subscription', subscriptionId],
    ]);
    return await httpRequest.get(`/integrations/stripe/invoices/upcoming`, {
        params,
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

// Subscriptions
export const listSubscriptions = async (companyId, customerId, currentPage, filters, includes, sorts) => {
    const params = new URLSearchParams([
        ['page', currentPage],
    ]);
    if (filters) for (const [key, value] of Object.entries(filters)) {
        params.set(key, value ?? "")
    }
    if (includes) params.set('include', includes)
    if (sorts) params.set('sort', sorts)
    return await httpRequest.get(`/subscriptions`, {
        params,
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const updateSubscription = async (companyId, customerId, subscriptionId, params) => {
    return await httpRequest.put(`/integrations/stripe/subscriptions/${subscriptionId}`, params, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

// Payments
export const listPayments = async (companyId, customerId, currentPage, filters, includes, sorts) => {
    const params = new URLSearchParams([
        ['page', currentPage],
    ]);
    if (filters) for (const [key, value] of Object.entries(filters)) {
        params.set(key, value ?? "")
    }
    if (includes) params.set('include', includes)
    if (sorts) params.set('sort', sorts)
    return await httpRequest.get(`/payments`, {
        params,
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const retrievePayment = async (companyId, customerId, payment) => {
    return await httpRequest.get(`/payments/${payment}`, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

// Payment methods
export const listPaymentMethods = async (companyId, customerId, currentPage, filters, includes, sorts) => {
    const params = new URLSearchParams([
        ['page', currentPage],
    ]);
    if (filters) for (const [key, value] of Object.entries(filters)) {
        params.set(key, value ?? "")
    }
    if (includes) params.set('include', includes)
    if (sorts) params.set('sort', sorts)
    return await httpRequest.get(`/customer/${customerId}/payment-methods`, {
        params,
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const retrievePaymentMethodStripe = async (companyId, customerId, paymentMethod) => {
    return await httpRequest.get(`/integrations/stripe/payment-methods/${paymentMethod}`, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const retrievePaymentIntentStripe = async (companyId, customerId, payment) => {
    return await httpRequest.get(`/integrations/stripe/payment-intents/${payment}`, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const detachPaymentMethod = async (companyId, customerId, paymentMethod) => {
    return await httpRequest.post(`/integrations/stripe/payment-methods/detach`, {paymentMethod}, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const createSetupIntent = async (companyId, customerId, paymentMethodId) => {
    const formData = new FormData()
    formData.set('customer', customerId)
    formData.set('payment_method', paymentMethodId)

    return await httpRequest.post(`/integrations/stripe/setup-intents`, formData, {
        headers: {'Pai-Company': companyId}
    })
}

// Invoices
export const getCatalogStates = async (countryId) => {
    return await httpRequest.get(`/integrations/invoicing/catalogs/${countryId}/states`)
}

export const getCatalogMunicipalities = async (stateId) => {
    return await httpRequest.get(`/integrations/invoicing/catalogs/${stateId}/municipalities`)
}

export const getCatalogFiscalRegimes = async (personType) => {
    return await httpRequest.get(`/integrations/invoicing/catalogs/fiscal-regimes/${personType}`)
}

export const getCatalogCFDIUses = async (fiscalRegime) => {
    return await httpRequest.get(`/integrations/invoicing/catalogs/cfdi-uses/${fiscalRegime}`)
}

export const getInvoicingProfile = async (companyId, customerId) => {
    return await httpRequest.get(`/integrations/invoicing/customers/${customerId}/invoicing-profile`, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const updateInvoice = async (companyId, invoiceId, data) => {
    return await httpRequest.put(`/integrations/stripe/invoices/${invoiceId}`, data , {
        headers: {'Pai-Company': companyId}
    })
}

export const updatePaymentIntent = async (companyId, paymentIntentId, data) => {
    return await httpRequest.put(`/integrations/stripe/payment-intents/${paymentIntentId}`, data, {
        headers: {'Pai-Company': companyId}
    })
}

export const confirmPaymentIntent = async (companyId, paymentIntentId, data) => {
    return await httpRequest.post(`/integrations/stripe/payment-intents/${paymentIntentId}/confirm`, data, {
        headers: {'Pai-Company': companyId}
    })
}

export const getListCfdis = async (companyId, customerId, currentPage, filters, includes, sorts) => {
    const params = new URLSearchParams([
        ['page', currentPage],
    ]);
    if (filters) for (const [key, value] of Object.entries(filters)) {
        params.set(key, value ?? "")
    }
    if (includes) params.set('include', includes)
    if (sorts) params.set('sort', sorts)
    return await httpRequest.get(`/integrations/invoicing/invoice-cfdis`, {
        params,
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const createInvoicingProfile = async (companyId, customerId, newInvoicingProfile) => {
    newInvoicingProfile.set('is_foreigner', 0)
    newInvoicingProfile.set('country', 'MEX')
    return await httpRequest.post(`/integrations/invoicing/customers/${customerId}/invoicing-profile`, newInvoicingProfile, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const createInvoiceCfdi = async (companyId, customerId, paymentId, data) => {
    return await httpRequest.post(`/integrations/invoicing/invoice-cfdis/${paymentId}`, data, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const getPaymentForms = async () => {
    return await httpRequest.get(`/integrations/invoicing/catalogs/payment-forms`)
}

export const retrieveCustomer = async (companyId, customerId) => {
    return await httpRequest.get(`/integrations/stripe/customers/${customerId}`, {
        headers: {'Pai-Company': companyId}
    })
}

export const cancelSubscription = async (companyId, customerId, subscriptionId, params) => {
    return await httpRequest.delete(`/integrations/stripe/subscriptions/${subscriptionId}`, {
        params: params,
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}

export const createBillingPortal = async (companyId, customerId, data) => {
    return await httpRequest.post(`/integrations/stripe/billing-portal`, data, {
        headers: {'Pai-Company': companyId, 'Pai-Customer': customerId}
    })
}
